<template>
    <div>
            <q-modal v-model="dialogVisible" no-backdrop-dismiss  @escape-key="unlockContragent">    
                <q-toolbar color="primary" style="justify-content:space-between;" class='contragent-dialog'>
                    <q-toolbar-title shrink>
                        <div v-if="data.id>-1">Редактирование контрагента</div>
                        <div v-if="data.id == -1">Создание нового контрагента</div>
                    </q-toolbar-title>
                </q-toolbar>       
                <form action="#" @submit.prevent="okDialog">  
                    <div class="dialog-container">
                        <div class="q-ma-xs q-pa-xs">
                            <q-input v-model="data.name" float-label="Наименование контрагента"/>
                        </div>
                        <div class="q-ma-xs">
                            <q-input v-model="data.contact" float-label="Контактное лицо"/>
                        </div>

                        <div class="row no-wrap q-ma-xs">
                            <div class="col">
                                <q-input v-model="data.phone" float-label="Контактный телефон"/>
                            </div>
                            <div class="col q-ml-lg">
                                <q-input v-model="data.email" float-label="e-mail" type="email"/>
                            </div>
                        </div>

                        <div class="q-ma-xs">
                            <q-input v-model="data.adress" float-label="Адрес доставки"/>
                        </div>

                        <div class="q-ma-xs">
                            <q-input v-model="data.comment" float-label="Комментарии"/>
                        </div>

                        <!-- выбор прайса -->
                        <div class='params-container q-ma-xs q-pa-sm round-borders q-mt-lg' style="border: 1px dotted gray;">
                            <div class='row no-wrap q-ma-sm  q-mb-sm '>
                                <q-select
                                        v-model="data.managerId"
                                        float-label="Менеджер"
                                        radio
                                        separator
                                        clearable
                                        :options="managerList"
                                        filter
                                        class="fit"
                                    />
                            </div>     
                            <div class='row no-wrap q-ma-sm  q-mb-sm '>

                                    <q-select
                                        v-model="data.priceId"
                                        float-label="Прайс-лист"
                                        radio
                                        separator
                                        clearable
                                        :options="priceList"
                                        filter
                                        class="fit"
                                    />

                            </div>
                            <!-- Параметры отсрочки -->

                            <div class="row no-wrap q-mb-sm">
                                <div class="col-4 q-ma-xs ellipsis ">
                                    <q-input v-model="data.postpay" float-label="Отсрочка платежа" placeholder="14"  style="width:150px"/>
                                </div>
                                <div class="col-4 q-ma-xs ellipsis">
                                    <q-input v-model="data.debitLimit" float-label="Лимит задолженности"  style="width:150px"/>
                                </div>
                                <div class="col-2 q-ma-xs ellipsis">
                                    <q-input v-model="data.discount" float-label="Cкидка от прайса" style="width:150px"/>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="button-container row no-wrap q-ma-sm justify-end ">
                        <q-btn label="отмена" icon="cancel" color="negative" outline  class="q-ma-sm" @click="cancelDialog" />
                        <q-btn label="сохранить" icon="save" color="positive" class="q-ma-sm" type="submit" :loading='loading' style="width:150px;"/>
                    </div>
                </form>
            </q-modal>
        
    </div>    
</template>

<script>
/* eslint-disable */
export default {
    name : 'contragentEditDialog',

    data() {
        return {

            dialogVisible : false,
            data : {},
            emptyData : {
                id : -1,
                name : '',
                comment : '',
                postpay : 14,
                debitLimit : 30000,
                priceId : undefined,
                discount : 0,
                managerId : undefined,
                contact : '',
                phone : '',
                email : '',
                adress : '',
            },
            loading : false,
        }
    },

    created() {
        eventBus.$on('openContragentEditDialog', this.openDialog);
        this.setEmptyData(); // присваиваем начальные значения диалоговому окну
        //Проверка наличия данных
        if (this.$store.getters.allUsers.length == 0) { // юзеров нет - пробуем загрузить
            this.$store.dispatch('retrieveUsers');
        }
        if (this.$store.getters.allPrices.length == 0) { // проверяем наличие прайсов
            this.$store.dispatch('retrievePrices');
        }
    },

    beforeDestroy() {
        eventBus.$off('openContragentEditDialog');
    },

    computed : {

        priceList() {
            
            return this.$store.getters.allPrices.map(item => {
                return {
                    label : item.name,
                    value : item.id
                }
            });
        },
        
        managerList() {
            return this.$store.getters.allUsers.map(item =>{
                return {
                    label : item.name,
                    value : item.id,
                }
            });
        },

    },

    methods : {

        unlockContragent(){
            if (this.data.id>-1) {
                this.$store.dispatch('unlockContragent', this.data.id)
                .then(()=>{

                })
                .catch(error=>{
                    this.$admns.showNotify('Не удалось разблокировать запись','error','Сообщение системы');
                    console.log(error);
                });
            }
        },

        setEmptyData() {
            this.data = Object.assign({}, this.emptyData);
        },

        openDialog(id){

            if (id>-1) { // если редактируем уже существующего контрагента - загружаем данные в него
                var q = this.$store.getters.getContragentById(id);
                if (q != undefined) this.data = Object.assign({}, q);
            } else this.setEmptyData(); // иначе обнуляем все поля ввода

            this.dialogVisible = true;

        },

        cancelDialog() {
            this.dialogVisible = false;
                this.unlockContragent();
        },

        okDialog() {
            if (this.data.name=='') {
                this.$admns.showNotify('Необходимо ввести имя контрагента','error','Сообщение системы');
                return;
            }
            if (this.data.priceId==undefined) {
                this.$admns.showNotify('Необходимо выбрать прайс-лист контрагента','error','Сообщение системы');
                return;
            }
            this.loading = true;
            this.$store.dispatch('saveContragent', this.data)
            .then(()=>{
                this.loading = false;
                this.dialogVisible = false;
                this.$admns.showNotify('Контрагент сохранен','success','Сообщение системы');
                if (this.data.id>-1) { // мы редактировали - поэтому стоит разблокировать запись.
                    this.unlockContragent();
                }
            })
            .catch((error)=>{
                this.loading = false;
                console.log(error);
                this.$admns.showNotify('Ошибка сохранения контрагента','error','Сообщение системы');
            });
            
        }


    }


}
</script>

<style lang="scss" scoped>
    .contragent-dialog {
        min-width:600px;
        width : 100%;
    }
    .dialog-container {
        min-height: 350px;
        padding: 20px;
    }
</style>



